import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { AddBankAccount } from './AddBankAccount';
import { ChooseBankAccount } from './ChooseBankAccount';
import { TwoFASetup } from './TwoFASetup';
import { WithdrawFinalCheck } from './WithdrawFinalCheck';
import { WithdrawInitial } from './WithdrawInitial';
import { WithdrawSuccess } from './WithdrawSuccess';
import { useAppSelector } from '../../../app/hooks';
import { Withdraw2FARequired } from './Withdraw2FARequired';
import { WithdrawAvailability } from './WithdrawAvailability';
import { WalletActivation } from './Withdraw.types';
import { ChooseWithdraw } from './ChooseWithdraw';

interface WithdrawProps {
  step: number;
  setStep: Dispatch<SetStateAction<number>>;
  setWithdraw: Dispatch<SetStateAction<boolean>>;
  setIsUSDTBalance: Dispatch<SetStateAction<boolean>>;
  isUSDTBalance: boolean;
  setNoKyc: Dispatch<SetStateAction<boolean>>;
}

export const Withdraw = ({
  step,
  setStep,
  setWithdraw,
  isUSDTBalance,
  setIsUSDTBalance,
  setNoKyc
}: WithdrawProps) => {
  const [amount, setAmount] = useState('');
  const [fee, setFee] = useState<number>(5);
  const [selectedWallet, setSelectedWallet] = useState<any>('');
  const [selectedNetwork, setSelectedNetwork] = useState<any>('');
  const [selectedToken, setSelectedToken] = useState<any>();
  const [isWithdrawSelected, setIsWithdrawSelected] = useState<boolean>(false);

  const [selected, setSelected] = useState(0);

  const { wallets } = useAppSelector((state) => state.wallets);

  const { info } = useAppSelector((state) => state.earnings);

  useEffect(() => {
    const firstActiveWallet = wallets.find(
      (wallet: any) => wallet.status === WalletActivation.ACTIVE
    );

    setSelectedWallet(firstActiveWallet);
  }, [wallets]);

  return (
    <>
      {step === 1 && (
        <WithdrawInitial
          isWithdrawSelected={isWithdrawSelected}
          setIsWithdrawSelected={setIsWithdrawSelected}
          setStep={setStep}
          userWallets={wallets}
          selected={selected}
          amount={amount}
          setAmount={setAmount}
          info={info}
          selectedNetwork={selectedNetwork}
          setSelectedNetwork={setSelectedNetwork}
          selectedToken={selectedToken}
          setSelectedToken={setSelectedToken}
          selectedWallet={selectedWallet}
          isUSDTBalance={isUSDTBalance}
          setFee={setFee}
          fee={fee}
        />
      )}

      {step === 2 && (
        <WithdrawFinalCheck
          selectedToken={selectedToken}
          setStep={setStep}
          amount={amount}
          selected={selected}
          selectedWallet={selectedWallet}
          selectedNetwork={selectedNetwork}
          setAmount={setAmount}
          fee={fee}
        />
      )}
      {step === 3 && <WithdrawSuccess setWithdraw={setWithdraw} />}

      {step === 4 && (
        <ChooseBankAccount
          setStep={setStep}
          selected={selected}
          setSelected={setSelected}
          userWallets={wallets}
          setSelectedWallet={setSelectedWallet}
        />
      )}

      {step === 5 && <AddBankAccount setStep={setStep} />}

      {step === 6 && (
        <TwoFASetup
          setStep={setStep}
          amount={amount}
          setAmount={setAmount}
          selected={selected}
          selectedWallet={selectedWallet}
          fee={fee}
          networkType={selectedNetwork?.networkType}
          selectedToken={selectedToken}
          isUSDTBalance={isUSDTBalance}
        />
      )}

      {step === 7 && (
        <ChooseWithdraw
          setStep={setStep}
          setIsUSDTBalance={setIsUSDTBalance}
          setNoKyc={setNoKyc}
          setFee={setFee}
          setSelectedNetwork={setSelectedNetwork}
        />
      )}

      {step === 8 && <Withdraw2FARequired />}

      {step === 9 && <WithdrawAvailability />}
    </>
  );
};
